import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="shell">
      <header className="topbar">
        <Link className="wordmark" to="/">
          AuxCast <span>listener</span>
        </Link>
      </header>
      <main>{children}</main>
    </div>
  );
}
